// @flow
import {
    Group,
    EntityList,
    PagerSettings,
    Product,
    Settings,
    Cart,
    User,
    Page,
    Error,
    Promotion,
    Order,
    SliderItem,
    ShopLink,
    OpenpayPlan,
    OrderResponse,
    AllCustomerReferrals,
    Representative
   // Translation

} from "../flow/types";

const initialState: {
    groups: EntityList<Group>,
    products: EntityList<Product>,
    featuredProducts: EntityList<Product>,
    recommendedProducts: EntityList<Product>,
    relatedProducts: EntityList<Product>,
    promotions: EntityList<Promotion>,
    sliderItems: EntityList<SliderItem>,
    orders: EntityList<Order>,
    cart: Cart,
    carts: EntityList<Cart> ,
    wishlist: Array<Product>,
    pager: PagerSettings,
    selectedProduct: Product,
    settings: Settings,
    siteLinks: Array<ShopLink>,
    user: User,
    page: Page,
    error: Error,
    orderResponse: OrderResponse,
    selectedOrder: Order,
    checkoutSale: object,
    locale: string,
    openpayPlan: OpenpayPlan,
    showLoader: Boolean,
    referrals: AllCustomerReferrals,
    representative: Representative,
    dashboard: {
    customerZoneBarData: { items: Array<any>, totalCount: number },
    customerZonePointsGraph: { items: Array<any>, totalCount: number },
    customerDashboardData: null,
    customerZoneData: null,
  }
  //  translations: Array<Translation>
} = {
    groups: new EntityList([], 0),
    products: new EntityList([], 0),
    featuredProducts: new EntityList([], 0),
    recommendedProducts: new EntityList([], 0),
    relatedProducts: new EntityList([], 0),
    promotions: new EntityList([], 0),
    sliderItems: new EntityList([], 0),
    orders: new EntityList([], 0),
    cart: new Cart(0, 'Default', true, null),
    carts: new EntityList([], 0),
    wishlist: [],
    pager: new PagerSettings(1, 1),
    selectedProduct: new Product(),
    settings: null, //new Settings("£", 12, 0, 0, "img/account/default-user-ava.png","dd/MM/yyyy"),
    siteLinks: {},
    user: new User(),
    page: new Page(),
    error: new Error(false, null, null),
    orderResponse: new OrderResponse(),
    selectedOrder: null,
    checkoutSale: null,
    locale: null,
    openpayPlan: null,
    showLoader: false,
    referrals: [],
    representative: null,
    dashboard: {
    customerZoneBarData: { items: [], totalCount: 0 },
    customerZonePointsGraph: { items: [], totalCount: 0 },
    customerDashboardData: null,
    customerZoneData: null,
  }
  //  translations: []
};

export default initialState;
